import { PopularityRankTypes, StreamingChartObjectType } from '@/@types/graphql-types';

const streamingChartCountries = [
	'GB',
	'US',
	'CA',
	'AU',
	'DE',
	'AT',
	'CH',
	'FR',
	'IT',
	'ES',
	'AR',
	'MX',
	'TR',
	'PT',
	'BR',
	'IN',

	'CL',
	'CO',
	'PH',
	'EG',
	'HU',
	// waiting for translations.
	// 'PL',
];
const streamingChartLandingPageCountries = [
	'AR',
	'AU',
	'BR',
	'CA',
	'ES',
	'EG',
	'FR',
	'DE',
	'IN',
	'IT',
	'MX',
	'PO',
	'PL',
	'TR',
	'US',
	'GB',
];

const reverseObjectTypeQueryMapping = {
	movies: StreamingChartObjectType.Movie,
	shows: StreamingChartObjectType.Show,
	seasons: StreamingChartObjectType.ShowSeason,
} as const;

const reverseCategoryQueryMapping = {
	daily: PopularityRankTypes.DailyPopularitySameContentType,
	weekly: PopularityRankTypes.WeeklyPopularitySameContentType,
	monthly: PopularityRankTypes.MonthlyPopularitySameContentType,
};

export {
	streamingChartCountries,
	streamingChartLandingPageCountries,
	reverseObjectTypeQueryMapping,
	reverseCategoryQueryMapping,
};
